import { atom } from "recoil";

const photoFourState =atom({
    key: 'photoFour',
    default: false
})

export default photoFourState